import React from 'react';
import { SUPPORTED_LANGUAGES, Language } from '../../types/language';
import { cn } from '../../lib/cn';
import { useLanguage } from '../../hooks/useLanguage';

interface LanguageDropdownProps {
  isOpen: boolean;
  activeLanguage: Language;
  onSelectLanguage: (lang: Language) => void;
  className?: string;
}

export const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  isOpen,
  activeLanguage,
  onSelectLanguage,
  className,
}) => {
  const { t } = useLanguage();
  return (
    <div
      className={cn(
        'absolute right-11 top-0 z-50 w-48 rounded-2xl border bg-white shadow-cardLg p-1.5',
        'border-ink-200/70 text-ink-700 max-h-[320px] overflow-y-auto no-scrollbar',
        'transition-all duration-200 origin-top-right transform',
        isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none',
        className
      )}
    >
      <div className="px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-ink-400 border-b border-ink-100/50 mb-1">
        {t("Select Language")}
      </div>
      <div className="flex flex-col gap-0.5">
        {SUPPORTED_LANGUAGES.map((lang) => {
          const isActive = lang.code === activeLanguage;
          return (
            <button
              key={lang.code}
              onClick={() => onSelectLanguage(lang.code)}
              className={cn(
                'w-full text-left px-3 py-2 rounded-xl text-xs font-semibold transition-all duration-150',
                isActive
                  ? 'bg-brand-50 text-brand-700'
                  : 'hover:bg-ink-100 text-ink-700 hover:text-ink-900'
              )}
            >
              <span className="block text-[13px]">{lang.nativeLabel}</span>
              <span className="block text-[10px] font-medium text-ink-400 leading-none">
                {lang.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
